import React from 'react';
import { ToggleWrapper, OptionButton } from './styled';

type Store = 'GOOGLE_PLAY' | 'APP_STORE';

interface StoreToggleProps {
  selectedStore?: Store;
  setSelectedStore: (store: Store) => void;
}

const StoreToggle: React.FC<StoreToggleProps> = ({
  selectedStore = 'GOOGLE_PLAY',
  setSelectedStore,
}) => {
  return (
    <ToggleWrapper>
      <OptionButton
        selected={selectedStore === 'GOOGLE_PLAY'}
        onClick={() => setSelectedStore('GOOGLE_PLAY')}
      >
        <input
          type="radio"
          value="GOOGLE_PLAY"
          name="selectedStore"
          defaultChecked
        />
        <img src="/images/uploads/google-play-logo.png" alt="Google Play" />
        <span>Google Play</span>
      </OptionButton>
      <OptionButton
        selected={selectedStore === 'APP_STORE'}
        onClick={() => setSelectedStore('APP_STORE')}
      >
        <input type="radio" value="APP_STORE" name="selectedStore" />
        <img src="/images/uploads/apple-logo.png" alt="App Store" />
        <span>App Store</span>
      </OptionButton>
    </ToggleWrapper>
  );
};

export default StoreToggle;
